import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'nrwl-multi-agent-picker',
  templateUrl: './multi-agent-picker.component.html',
  styleUrls: ['./multi-agent-picker.component.scss']
})
export class MultiAgentPickerComponent implements OnInit {
  originator: any;
  destination: any;
  persistenceID: string;
  singleSelection: boolean;
  cartView: boolean;
  cartItems = [];
  transformationString: string;
  preSelectedDevices: any;
  dataSource: BehaviorSubject<any[]>;
  pageConfigurations: any;
  havingChildRows: boolean;
  selectionLimit = 1300;
  constructor(
    public dialogRef: MatDialogRef<MultiAgentPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dataSource = new BehaviorSubject<any[]>([]);
  }

  ngOnInit(): void {
    this.assignParamsData();
  }

  assignParamsData(): void {
    if (this.data) {
      this.selectionLimit = this.data.maxDeviceCount;
      if (this.data.preSelectedDevices && this.data.preSelectedDevices.length > 0) {
        this.preSelectedDevices = this.data.preSelectedDevices;
      }

      if (this.data.cartView) {
        this.cartView = this.data.cartView;
      }
      if (this.data.cartItems) {
        this.cartItems = this.data.cartItems;
      }
      if (this.data?.originator) {
        this.originator = this.data.originator;
        this.formatOriginator();
        this.dataSource.next(this.originator);
      }
      if (this.data?.destination) {
        this.dataSource.next(this.data.destination);
        this.destination = this.data.destination;
      }
      this.havingChildRows = this.data.havingChildRows;
      this.pageConfigurations = this.data.pageConfigurations;
      this.singleSelection = this.data.singleSelection;
      this.persistenceID = this.data.persistenceID;
      this.transformationString = this.data.transformationString;
    }
  }

  formatOriginator(): void {
    if (this.originator.length) {
      this.originator.forEach(item => (item.deviceData['isChecked'] = false));
      if (this.preSelectedDevices && this.preSelectedDevices.length > 0) {
        const result = this.originator.map(el => {
          if (this.preSelectedDevices.find(filteredId => el.deviceData.id === filteredId.id)) {
            el.deviceData['isChecked'] = true;
          }
          return el;
        });
        this.originator = result;
      }
    }
  }

  closeModal(data: any): void {
    this.dialogRef.close(data);
  }
}
